/*
Custom JS file enqueued only on product templates as of now
*/

(function($){

    $(document).ready(function() {
   
        tippy.setDefaultProps({
           placement: 'right',
             popperOptions: {
               modifiers: [
                   {
                     name: 'flip',
                     options: {
                       fallbackPlacements: ['top'],
                     },
                   },
                   {
                     name: 'preventOverflow',
                     options: {
                       altAxis: true,
                       tether: false,
                     },
                   },
                 ],
             },
         });
   
        tippy('.sk-tt-shoulder', {
           content: 'Measure at highest point of armhole, straight across from seam to seam'
        });
       
        tippy('.sk-tt-bust', {
           content: 'Measure at the fullest part around the bust'
       });
       
        tippy('.sk-tt-waist', {
           content: 'Measure around the waistline where you wear your pants'
        });
       
        tippy('.sk-tt-stomach', {
           content: 'Measure at the fullest part around the waist'
       });
        tippy('.sk-tt-hip', {
           content: 'Measure at the fullest part around the hips'
       });
 
        var skValidator = $(".ProductForm").validate({
         rules: {
             "properties[Shoulder]": {
                 required: true,
                 number: true
             },
             "properties[Bust]": {
                 required: true,
                 number: true
             },
             "properties[Waist]": {
                 required: true,
                 number: true
             },
            "properties[Stomach]": {
                 required: true,
                 number: true
             },
             "properties[Hip]": {
                 required: true,
                 number: true
             }
         },
       errorPlacement:function(error,element){
          error.appendTo(element.parent().after());
     },
       errorElement: "div"
     });
 
        function skValidCustomMeasurements() {          
            $('.ProductForm__AddToCart, button.shopify-payment-button__button').on("click", function(event) {
                 if(skValidator.form() == false)
                 {
                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                 }
                 else {
                     return true;
                 }
             });
         }

    
        $(document).on("change",'input.SizeSwatch__Radio',function(){
            var skProductSizeLabel= $(this).parent(".HorizontalList__Item").find("label").text().trim();
          //  console.log("change, label is " + skProductSizeLabel);
            if(skProductSizeLabel== "Custom") {
                $(".line-item-property__field").slideDown();
                skValidCustomMeasurements();
            }
            else {
                $(".line-item-property__field").slideUp();
               // skValidator.destroy(); 
            }        
        });

        $(window).on("load", function() {
            var skProductSizeOnLoad = $('input.SizeSwatch__Radio:checked').val();
         //   console.log("on load, label is" + skProductSizeOnLoad);
            if(skProductSizeOnLoad== "Custom") {
                $(".line-item-property__field").slideDown();
                skValidCustomMeasurements();
            }
            else {
                $(".line-item-property__field").slideUp();
               // skValidator.destroy(); 
            }
        });

     });
   })(jQuery);